import { Fab as MuiFab } from '@mui/material';
import React, { ReactNode } from 'react';

type PropsTypes = {
  icon: ReactNode;
  onClick?: any;
  background?: string;
  style?: any;
  size?: any;
  disabled?: boolean;
};

export default function Fab(props: PropsTypes) {
  const {
    icon,
    onClick,
    background,
    style,
    size = 'small',
    disabled = false,
  } = props;
  return (
    <MuiFab
      disabled={disabled}
      onClick={onClick}
      size={size}
      style={style}
      sx={{
        '&:hover': {
          background,
        },
        background,
        boxShadow: 'none',
      }}
    >
      {icon}
    </MuiFab>
  );
}
